<template>
  <div class="row">
    <div class="col-md-12">
      <card title="Transactions">
        <transaction-table
          :poolId="poolId"
          :perPage="100"
          :showPagination="true"
        />
      </card>
    </div>
  </div>
</template>

<script>
import TransactionTable from "../components/Tables/TransactionTable.vue";
import Card from "../components/Cards/Card.vue";

export default {
  components: {
    TransactionTable,
    Card
  },
  props: {
    poolId: String
  }
};
</script>
